import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import WaitForGoogleMaps from '../../../common/WaitForGoogleMaps';
import CircleOverlayCreator from './CircleOverlay';
import { createMap } from '../../../services/maps';
import { GPoint } from '../../MatchModel';

class CircleMap extends PureComponent {
  constructor(props) {
    super(props);

    this.onResize = this.onResize.bind(this);
    this.setupMap = this.setupMap.bind(this);
    this.zoomToCircle = this.zoomToCircle.bind(this);
    this.zoomOnResize = this.zoomOnResize.bind(this);

    this.animationFrame = null;
    this.map = null;
    this.mapCanvas = null;
  }


  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentDidUpdate() {
    this.overlay.setProps({
      progress: this.props.progress,
      radius: this.props.radius,
      center: this.props.circlePosition.toLatLng()
    });

    this.zoomToCircle(this.props);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);

    if (this.animationFrame) {
      window.cancelAnimationFrame(this.animationFrame);
    }
  }

  onResize() {
    if (this.map) {
      this.animationFrame = window.requestAnimationFrame(this.zoomToCircle);
    }
  }

  setupMap(canvas) {
    this.mapCanvas = canvas;

    if (canvas) {
      const center = this.props.circlePosition.toLatLng();

      this.map = createMap(this.mapCanvas, center, 15);
      this.overlay = new (CircleOverlayCreator())({
        progress: this.props.progress,
        radius: this.props.radius,
        center
      });
      this.overlay.setMap(this.map);

      this.zoomToCircle();
    }
  }

  zoomToCircle() {
    const props = this.overlay.props;

    const spherical = global.google.maps.geometry.spherical;

    const north = spherical.computeOffset(props.center, props.radius, 0);
    const east = spherical.computeOffset(props.center, props.radius, 90);
    const south = spherical.computeOffset(props.center, props.radius, 180);
    const west = spherical.computeOffset(props.center, props.radius, 270);

    const ne = { lat: north.lat(), lng: east.lng() };
    const sw = { lat: south.lat(), lng: west.lng() };

    this.map.fitBounds(new global.google.maps.LatLngBounds(sw, ne), 5);
  }

  zoomOnResize() {
    this.animationFrame = null;
    this.zoomToCircle();
  }

  render() {
    return (
      <div className={this.props.className} ref={this.setupMap} />
    );
  }
}

CircleMap.propTypes = {
  className: PropTypes.string,
  progress: PropTypes.number.isRequired,
  radius: PropTypes.number.isRequired,
  circlePosition: GPoint.propType.isRequired
};

CircleMap.defaultProps = {
  className: ''
};

export default WaitForGoogleMaps(CircleMap);
